export enum Flag {
  RED = 'RED',
  YELLOW = 'YELLOW',
  ORANGE = 'ORANGE',
  TEAL = 'TEAL',
  GREEN = 'GREEN'
}
